import { render, staticRenderFns } from "./orgTree.vue?vue&type=template&id=1013ea73&scoped=true"
import script from "./orgTree.vue?vue&type=script&lang=js"
export * from "./orgTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1013ea73",
  null
  
)

export default component.exports